export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    gimcheon: '2026 Gimcheon',
    announcement: 'Announcement',
    contact: 'Contact',
    login: 'Login',
    signUp: 'Sign Up',
    privacy: 'Privacy Policy'
  },
  hero: {
    title: 'Gimcheon World Cup',
    subtitle: 'GIMCHEON WORLD CHAMPIONSHIPS',
    description: '',
    cta: 'Register Now',
    registerNow: 'Register Now',
    learnMore: 'Learn More',
    guidelinesTitle: 'Competition Guidelines',
    guidelinesEnglish: 'English Guidelines',
    guidelinesKorean: 'Korean Guidelines',
    travelAgency: 'Official Travel & Tour Agency',
    kombatGuidelines: 'Kombat Taekwondo League Guidelines'
  },
  about: {
    title: 'About Us',
    subtitle: '',
    description: 'With decades of dedication to Taekwondo, our World Champion has achieved the highest honors in international competition. From Olympic medals to World Championship titles, the journey represents unwavering commitment to martial arts excellence.',
    experience: 'Years of Experience',
    students: 'Students Trained',
    medals: 'International Medals',
    stats: {
      years: 'Years of Experience',
      students: 'Students Trained',
      medals: 'International Medals'
    },
    philosophy: 'Training Philosophy',
    philosophyText: 'True mastery comes from the perfect balance of physical technique, mental discipline, and spiritual growth. Every student has the potential to become a champion in their own right.'
  },
  gimcheon: {
    badge: 'UPCOMING EVENT',
    title: '2026 Gimcheon World Championships',
    mainTitle: 'A Global Open Championship for All Taekwondo Athletes',
    description1: 'The 2026 Gimcheon World Taekwondo Championships is an international open event welcoming athletes from around the world. This unique championship brings together WT (Olympic), ITF (Traditional), and Kombat Taekwondo on one global stage.',
    description2: 'From beginners to elite athletes, from children to masters — all nationalities, ages, and belt levels are welcome.',
    description3: '',
    subtitle: '',
    dateLabel: 'Event Date',
    date: 'July 11-12, 2026',
    eventDate: '2026.07.11-12',
    dateText: 'Date',
    locationLabel: 'Location',
    location: 'Gimcheon Sports Complex, South Korea',
    venue: 'Gimcheon gymnasium',
    venueLocation: 'Gimcheon Sports Complex, 1 Undongjang-gil, Gimcheon-si, Gyeongbuk, South Korea',
    categoriesLabel: 'Categories',
    categories: 'All Age Groups & Weight Classes',
    deadline: 'Early registration deadline: March 31, 2026',
    registerButton: 'Register Now',
    registerTitle: 'Register to the World Taekwondo Championships',
    joinUs: 'Join us',
    register: 'Register',
    international: 'International Participation',
    internationalDesc: 'Athletes from over 50 countries competing at the highest level of Taekwondo excellence.',
    competition: 'World-Class Facilities',
    competitionDesc: 'Olympic-standard competition venues with state-of-the-art equipment and professional judging.',
    streaming: 'Live Coverage',
    streamingDesc: 'Professional live streaming and broadcast coverage reaching millions of viewers worldwide.',
    cultural: 'Cultural Exchange',
    culturalDesc: 'Workshops, seminars, and cultural programs celebrating the spirit and tradition of martial arts.',
    travelAgency: {
      title: 'Official Partner Travel Agency',
      description: 'The championship is operated in cooperation with an official partner travel agency to support international participants and teams.',
      servicesTitle: 'Through the link below, you can find:',
      service1: 'Athlete accommodation packages',
      service2: 'Airport pickup & local transportation',
      service3: 'Korea cultural tours',
      service4: 'Training camp & competition-related travel services',
      cta: 'Make your participation in the championship easier and more comfortable.'
    }
  },
  training: {
    title: 'Training & Classes',
    subtitle: 'Programs for Every Level',
    beginners: 'Beginners Program',
    beginnersDesc: 'Perfect for those new to Taekwondo. Learn fundamental techniques, basic forms, and essential discipline in a supportive environment.',
    intermediate: 'Intermediate Training',
    intermediateDesc: 'Advance your skills with complex techniques, sparring practice, and competitive preparation. Build strength and confidence.',
    advanced: 'Advanced & Competition',
    advancedDesc: 'Elite training for serious competitors. Master advanced techniques, strategic sparring, and championship-level performance.',
    private: 'Private Coaching',
    privateDesc: 'One-on-one sessions with the World Champion. Personalized training plans tailored to your specific goals and abilities.',
    kids: 'Kids Classes',
    kidsDesc: 'Fun and engaging classes for children ages 5-12. Develop discipline, respect, coordination, and confidence through Taekwondo.',
    adults: 'Adult Classes',
    adultsDesc: 'Comprehensive training for adults of all fitness levels. Improve health, learn self-defense, and achieve personal growth.'
  },
  gallery: {
    title: 'Gallery & Posters',
    subtitle: 'Moments of Glory',
    viewAll: 'View All Photos'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Start Your Journey Today',
    teamName: 'Team Name',
    teamNamePlaceholder: 'Enter your team name',
    country: 'Country',
    countryPlaceholder: 'Select your country',
    contactPerson: 'Contact Person Name',
    contactPersonPlaceholder: 'Enter contact person name',
    name: 'Your Name',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    phone: 'Phone Number',
    phoneNumber: 'Phone number',
    contactMethod: 'Preferred Contact Method',
    contactValue: 'Contact Value',
    phoneLabel: 'Phone Number',
    whatsappLabel: 'WhatsApp Number',
    telegramLabel: 'Telegram Username',
    wechatLabel: 'WeChat ID',
    phonePlaceholder: '+82 10-1234-5678',
    whatsappPlaceholder: '+82 10-1234-5678',
    telegramPlaceholder: '@username',
    wechatPlaceholder: 'WeChat ID',
    message: 'Message',
    messagePlaceholder: 'Tell us about your team and registration details',
    messageLimit: 'Maximum 500 characters',
    submit: 'Submit',
    submitting: 'Submitting...',
    successMessage: 'Thank you for your information. We will contact you back in 24 hours.',
    errorMessage: 'Failed to submit registration. Please try again.',
    send: 'Send Message',
    info: 'Contact Information',
    address: 'Address',
    addressText: 'Gimcheon Sports Complex, 1 Undongjang-gil, Gimcheon-si, Gyeongbuk, South Korea',
    hours: 'Training Hours',
    hoursText: 'Monday - Friday: 6:00 AM - 9:00 PM\nSaturday: 8:00 AM - 6:00 PM\nSunday: 9:00 AM - 3:00 PM',
    followUs: 'Follow Us'
  },
  footer: {
    tagline: 'World Sports Committee (Incorporated Association)',
    quickLinks: 'Quick Links',
    copyright: '© 2025 GCWC Taekwondo. All rights reserved.',
    poweredBy: 'Powered by Readdy'
  },
  popup: {
    badge: 'REGISTER COMPETITION',
    title: '2026 Gimcheon World Championships',
    dateLabel: 'Date',
    date: 'July 11-12, 2026',
    locationLabel: 'Location',
    location: 'Gimcheon Sports Complex, 1 Undongjang-gil, Gimcheon-si, Gyeongbuk, South Korea',
    categoriesLabel: 'Categories',
    categories: 'All Age Groups & Weight Classes',
    highlightsTitle: 'Competition Highlights',
    highlight1: 'International athletes',
    highlight2: 'Olympic-standard competition facilities',
    highlight3: 'Live streaming and professional coverage',
    highlight4: 'Cultural exchange programs and workshops',
    applyButton: 'Apply Here',
    registerButton: 'Register Now',
    registerHereButton: 'Register Here',
    closeButton: 'Close',
    deadline: 'Early registration deadline: March 31, 2026'
  },
  competitionButton: {
    text: 'Register Competition',
    shortText: 'Register Competition'
  },
  login: {
    title: 'Welcome Back',
    subtitle: 'Login to your account to continue',
    email: 'Email Address',
    emailPlaceholder: 'Enter your email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot Password?',
    loginButton: 'Login',
    or: 'OR',
    googleLogin: 'Continue with Google',
    facebookLogin: 'Continue with Facebook',
    noAccount: "Don't have an account?",
    signUpLink: 'Sign Up',
    termsText: 'By logging in, you agree to our',
    termsLink: 'Terms & Conditions'
  },
  signup: {
    title: 'Create Account',
    subtitle: 'Join our Taekwondo community today',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter your full name',
    email: 'Email Address',
    emailPlaceholder: 'Enter your email',
    password: 'Password',
    passwordPlaceholder: 'Create a password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm your password',
    phone: 'Phone Number',
    phonePlaceholder: 'Enter your phone number',
    dateOfBirth: 'Date of Birth',
    beltLevel: 'Current Belt Level',
    selectBelt: 'Select your belt level',
    whiteBelt: 'White Belt',
    yellowBelt: 'Yellow Belt',
    greenBelt: 'Green Belt',
    blueBelt: 'Blue Belt',
    redBelt: 'Red Belt',
    blackBelt: 'Black Belt',
    agreeText: 'I agree to the',
    termsLink: 'Terms & Conditions',
    and: 'and',
    privacyLink: 'Privacy Policy',
    signUpButton: 'Create Account',
    or: 'OR',
    googleSignUp: 'Sign up with Google',
    facebookSignUp: 'Sign up with Facebook',
    haveAccount: 'Already have an account?',
    loginLink: 'Login',
    passwordMismatch: 'Passwords do not match',
    agreeTermsRequired: 'You must agree to the terms and conditions'
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated',
    introduction: {
      title: 'Introduction',
      content: 'Welcome to GCWC (Gimcheon World Champions). We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.'
    },
    infoCollect: {
      title: 'Information We Collect',
      content: 'We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:',
      item1: 'Identity Data: includes first name, last name, username or similar identifier',
      item2: 'Contact Data: includes email address and telephone numbers',
      item3: 'Technical Data: includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform',
      item4: 'Usage Data: includes information about how you use our website, products and services'
    },
    howWeUse: {
      title: 'How We Use Your Information',
      content: 'We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:',
      item1: 'To register you as a new student or member',
      item2: 'To process and manage your registration for competitions',
      item3: 'To manage our relationship with you, including notifying you about changes to our services',
      item4: 'To improve our website, products/services, marketing or customer relationships'
    },
    adsense: {
      title: 'Google AdSense and Advertising',
      content: 'We use Google AdSense to display advertisements on our website. Google AdSense uses cookies to serve ads based on your prior visits to our website or other websites.',
      cookies: 'Google\'s use of advertising cookies enables it and its partners to serve ads to you based on your visit to our sites and/or other sites on the Internet.',
      optOut: 'You may opt out of personalized advertising by visiting:'
    },
    cookies: {
      title: 'Cookies and Tracking Technologies',
      content: 'Our website uses cookies to distinguish you from other users of our website. This helps us to provide you with a good experience when you browse our website and also allows us to improve our site. The types of cookies we use include:',
      item1: 'Strictly necessary cookies: These are required for the operation of our website',
      item2: 'Analytical/performance cookies: These allow us to recognize and count the number of visitors and see how visitors move around our website',
      item3: 'Functionality cookies: These are used to recognize you when you return to our website'
    },
    security: {
      title: 'Data Security',
      content: 'We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. We limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.'
    },
    thirdParty: {
      title: 'Third-Party Links',
      content: 'Our website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements.'
    },
    children: {
      title: 'Children\'s Privacy',
      content: 'Our services are intended for individuals who are at least 13 years old. We do not knowingly collect personal information from children under 13. If we become aware that a child under 13 has provided us with personal information, we will take steps to delete such information.'
    },
    rights: {
      title: 'Your Rights',
      content: 'Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to:',
      item1: 'Request access to your personal data',
      item2: 'Request correction of your personal data',
      item3: 'Request erasure of your personal data',
      item4: 'Object to processing of your personal data'
    },
    changes: {
      title: 'Changes to This Privacy Policy',
      content: 'We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last Updated" date at the top of this privacy policy.'
    },
    contact: {
      title: 'Contact Us',
      content: 'If you have any questions about this privacy policy or our privacy practices, please contact us at:'
    }
  }
};
